/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as EarlyAccessRouteImport } from './routes/early-access'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ManageRouteImport } from './routes/manage'
import { Route as MfaEnrollmentRouteImport } from './routes/mfa-enrollment'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as ManageIndexRouteImport } from './routes/manage.index'
import { Route as PShareIdRouteImport } from './routes/p.$shareId'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as VisualQaRenderRouteImport } from './routes/visual-qa.render'
import { Route as ManageCompanySlugAiActionsRouteImport } from './routes/manage.$companySlug.ai-actions'
import { Route as ManageCompanySlugAssetsRouteImport } from './routes/manage.$companySlug.assets'
import { Route as ManageCompanySlugDashboardRouteImport } from './routes/manage.$companySlug.dashboard'
import { Route as ManageCompanySlugPresentationsRouteImport } from './routes/manage.$companySlug.presentations'
import { Route as ManageCompanySlugProjectsRouteImport } from './routes/manage.$companySlug.projects'
import { Route as ManageCompanySlugSettingsRouteImport } from './routes/manage.$companySlug.settings'
import { Route as ManageCompanySlugTemplateCategoriesRouteImport } from './routes/manage.$companySlug.template-categories'
import { Route as ManageCompanySlugTemplatesRouteImport } from './routes/manage.$companySlug.templates'
import { Route as ManageAccountSecurityRouteImport } from './routes/manage.account.security'
import { Route as ManageAccountSessionsRouteImport } from './routes/manage.account.sessions'
import { Route as PShareIdIndexRouteImport } from './routes/p.$shareId.index'
import { Route as ManageCompanySlugAssetsAssetIdRouteImport } from './routes/manage.$companySlug.assets_.$assetId'
import { Route as ManageCompanySlugPresentationCopyProposalsProposalIdRouteImport } from './routes/manage.$companySlug.presentation-copy-proposals.$proposalId'
import { Route as ManageCompanySlugProjectsIndexRouteImport } from './routes/manage.$companySlug.projects.index'
import { Route as ManageCompanySlugProjectsProjectIdRouteImport } from './routes/manage.$companySlug.projects.$projectId'
import { Route as ManageCompanySlugProjectsNewRouteImport } from './routes/manage.$companySlug.projects.new'
import { Route as ManageCompanySlugSettingsIndexRouteImport } from './routes/manage.$companySlug.settings.index'
import { Route as ManageCompanySlugSettingsAiProviderRouteImport } from './routes/manage.$companySlug.settings.ai-provider'
import { Route as ManageCompanySlugSettingsAuditLogRouteImport } from './routes/manage.$companySlug.settings.audit-log'
import { Route as ManageCompanySlugSettingsCompanyRouteImport } from './routes/manage.$companySlug.settings.company'
import { Route as ManageCompanySlugSettingsInvitationsRouteImport } from './routes/manage.$companySlug.settings.invitations'
import { Route as ManageCompanySlugSettingsMembersRouteImport } from './routes/manage.$companySlug.settings.members'
import { Route as ManageCompanySlugSettingsSecurityRouteImport } from './routes/manage.$companySlug.settings.security'
import { Route as PShareIdSSlidePublicIdRouteImport } from './routes/p.$shareId.s.$slidePublicId'
import { Route as ManageCompanySlugProjectsProjectIdIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.index'
import { Route as ManageCompanySlugProjectsProjectIdAccessRouteImport } from './routes/manage.$companySlug.projects.$projectId.access'
import { Route as ManageCompanySlugProjectsProjectIdAssetsRouteImport } from './routes/manage.$companySlug.projects.$projectId.assets'
import { Route as ManageCompanySlugProjectsProjectIdKnowledgeRouteImport } from './routes/manage.$companySlug.projects.$projectId.knowledge'
import { Route as ManageCompanySlugProjectsProjectIdOverviewRouteImport } from './routes/manage.$companySlug.projects.$projectId.overview'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations'
import { Route as ManageCompanySlugProjectsProjectIdSettingsRouteImport } from './routes/manage.$companySlug.projects.$projectId.settings'
import { Route as ManageCompanySlugProjectsProjectIdThemeRouteImport } from './routes/manage.$companySlug.projects.$projectId.theme'
import { Route as ManageCompanySlugSettingsInvitationsNewRouteImport } from './routes/manage.$companySlug.settings.invitations_.new'
import { Route as ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRouteImport } from './routes/manage.$companySlug.share-link-change-proposals.$presentationId.$proposalId'
import { Route as ManageCompanySlugTemplatesNewDynamicHtmlRouteImport } from './routes/manage.$companySlug.templates_.new.dynamic-html'
import { Route as ManageCompanySlugProjectsProjectIdAiProposalsIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.ai-proposals.index'
import { Route as ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRouteImport } from './routes/manage.$companySlug.projects.$projectId.ai-proposals.$proposalId'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.index'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsNewRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.new'
import { Route as ManageCompanySlugSettingsMembersUserIdAccessRouteImport } from './routes/manage.$companySlug.settings.members_.$userId.access'
import { Route as ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRouteImport } from './routes/manage.$companySlug.templates_.$templateId.drafts.$draftId'
import { Route as ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteImport } from './routes/manage.$companySlug.templates_.$templateId.versions.$version'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.index'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.access'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.analytics'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.overview'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.preview'
import { Route as ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRouteImport } from './routes/manage.$companySlug.templates_.$templateId.versions.$version.edit'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.present.index'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.present.$slideId'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.present.audience'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.settings.appearance'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.settings.variables'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.shares.index'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.shares.new'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.slides.$slideId'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.shares.$shareLinkId.index'
import { Route as ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRouteImport } from './routes/manage.$companySlug.projects.$projectId.presentations.$presentationId.shares.$shareLinkId.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const EarlyAccessRoute = EarlyAccessRouteImport.update({
  id: '/early-access',
  path: '/early-access',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageRoute = ManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaEnrollmentRoute = MfaEnrollmentRouteImport.update({
  id: '/mfa-enrollment',
  path: '/mfa-enrollment',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageIndexRoute = ManageIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManageRoute,
} as any)
const PShareIdRoute = PShareIdRouteImport.update({
  id: '/p/$shareId',
  path: '/p/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const VisualQaRenderRoute = VisualQaRenderRouteImport.update({
  id: '/visual-qa/render',
  path: '/visual-qa/render',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageCompanySlugAiActionsRoute =
  ManageCompanySlugAiActionsRouteImport.update({
    id: '/$companySlug/ai-actions',
    path: '/$companySlug/ai-actions',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugAssetsRoute = ManageCompanySlugAssetsRouteImport.update({
  id: '/$companySlug/assets',
  path: '/$companySlug/assets',
  getParentRoute: () => ManageRoute,
} as any)
const ManageCompanySlugDashboardRoute =
  ManageCompanySlugDashboardRouteImport.update({
    id: '/$companySlug/dashboard',
    path: '/$companySlug/dashboard',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugPresentationsRoute =
  ManageCompanySlugPresentationsRouteImport.update({
    id: '/$companySlug/presentations',
    path: '/$companySlug/presentations',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugProjectsRoute =
  ManageCompanySlugProjectsRouteImport.update({
    id: '/$companySlug/projects',
    path: '/$companySlug/projects',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugSettingsRoute =
  ManageCompanySlugSettingsRouteImport.update({
    id: '/$companySlug/settings',
    path: '/$companySlug/settings',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugTemplateCategoriesRoute =
  ManageCompanySlugTemplateCategoriesRouteImport.update({
    id: '/$companySlug/template-categories',
    path: '/$companySlug/template-categories',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugTemplatesRoute =
  ManageCompanySlugTemplatesRouteImport.update({
    id: '/$companySlug/templates',
    path: '/$companySlug/templates',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageAccountSecurityRoute = ManageAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => ManageRoute,
} as any)
const ManageAccountSessionsRoute = ManageAccountSessionsRouteImport.update({
  id: '/account/sessions',
  path: '/account/sessions',
  getParentRoute: () => ManageRoute,
} as any)
const PShareIdIndexRoute = PShareIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PShareIdRoute,
} as any)
const ManageCompanySlugAssetsAssetIdRoute =
  ManageCompanySlugAssetsAssetIdRouteImport.update({
    id: '/$companySlug/assets_/$assetId',
    path: '/$companySlug/assets/$assetId',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugPresentationCopyProposalsProposalIdRoute =
  ManageCompanySlugPresentationCopyProposalsProposalIdRouteImport.update({
    id: '/$companySlug/presentation-copy-proposals/$proposalId',
    path: '/$companySlug/presentation-copy-proposals/$proposalId',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugProjectsIndexRoute =
  ManageCompanySlugProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ManageCompanySlugProjectsRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdRoute =
  ManageCompanySlugProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => ManageCompanySlugProjectsRoute,
  } as any)
const ManageCompanySlugProjectsNewRoute =
  ManageCompanySlugProjectsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ManageCompanySlugProjectsRoute,
  } as any)
const ManageCompanySlugSettingsIndexRoute =
  ManageCompanySlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugSettingsAiProviderRoute =
  ManageCompanySlugSettingsAiProviderRouteImport.update({
    id: '/ai-provider',
    path: '/ai-provider',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugSettingsAuditLogRoute =
  ManageCompanySlugSettingsAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugSettingsCompanyRoute =
  ManageCompanySlugSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugSettingsInvitationsRoute =
  ManageCompanySlugSettingsInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugSettingsMembersRoute =
  ManageCompanySlugSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugSettingsSecurityRoute =
  ManageCompanySlugSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const PShareIdSSlidePublicIdRoute = PShareIdSSlidePublicIdRouteImport.update({
  id: '/s/$slidePublicId',
  path: '/s/$slidePublicId',
  getParentRoute: () => PShareIdRoute,
} as any)
const ManageCompanySlugProjectsProjectIdIndexRoute =
  ManageCompanySlugProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdAccessRoute =
  ManageCompanySlugProjectsProjectIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdAssetsRoute =
  ManageCompanySlugProjectsProjectIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdKnowledgeRoute =
  ManageCompanySlugProjectsProjectIdKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdOverviewRoute =
  ManageCompanySlugProjectsProjectIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdPresentationsRoute =
  ManageCompanySlugProjectsProjectIdPresentationsRouteImport.update({
    id: '/presentations',
    path: '/presentations',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdSettingsRoute =
  ManageCompanySlugProjectsProjectIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdThemeRoute =
  ManageCompanySlugProjectsProjectIdThemeRouteImport.update({
    id: '/theme',
    path: '/theme',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugSettingsInvitationsNewRoute =
  ManageCompanySlugSettingsInvitationsNewRouteImport.update({
    id: '/invitations_/new',
    path: '/invitations/new',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute =
  ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRouteImport.update(
    {
      id: '/$companySlug/share-link-change-proposals/$presentationId/$proposalId',
      path: '/$companySlug/share-link-change-proposals/$presentationId/$proposalId',
      getParentRoute: () => ManageRoute,
    } as any,
  )
const ManageCompanySlugTemplatesNewDynamicHtmlRoute =
  ManageCompanySlugTemplatesNewDynamicHtmlRouteImport.update({
    id: '/$companySlug/templates_/new/dynamic-html',
    path: '/$companySlug/templates/new/dynamic-html',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute =
  ManageCompanySlugProjectsProjectIdAiProposalsIndexRouteImport.update({
    id: '/ai-proposals/',
    path: '/ai-proposals/',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute =
  ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRouteImport.update({
    id: '/ai-proposals/$proposalId',
    path: '/ai-proposals/$proposalId',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdPresentationsIndexRoute =
  ManageCompanySlugProjectsProjectIdPresentationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdPresentationsRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteImport.update(
    {
      id: '/$presentationId',
      path: '/$presentationId',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsNewRoute =
  ManageCompanySlugProjectsProjectIdPresentationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ManageCompanySlugProjectsProjectIdPresentationsRoute,
  } as any)
const ManageCompanySlugSettingsMembersUserIdAccessRoute =
  ManageCompanySlugSettingsMembersUserIdAccessRouteImport.update({
    id: '/members_/$userId/access',
    path: '/members/$userId/access',
    getParentRoute: () => ManageCompanySlugSettingsRoute,
  } as any)
const ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute =
  ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRouteImport.update({
    id: '/$companySlug/templates_/$templateId/drafts/$draftId',
    path: '/$companySlug/templates/$templateId/drafts/$draftId',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugTemplatesTemplateIdVersionsVersionRoute =
  ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteImport.update({
    id: '/$companySlug/templates_/$templateId/versions/$version',
    path: '/$companySlug/templates/$templateId/versions/$version',
    getParentRoute: () => ManageRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRouteImport.update(
    {
      id: '/access',
      path: '/access',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRouteImport.update(
    {
      id: '/analytics',
      path: '/analytics',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRouteImport.update(
    {
      id: '/preview',
      path: '/preview',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute =
  ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      ManageCompanySlugTemplatesTemplateIdVersionsVersionRoute,
  } as any)
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRouteImport.update(
    {
      id: '/present/',
      path: '/present/',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRouteImport.update(
    {
      id: '/present/$slideId',
      path: '/present/$slideId',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRouteImport.update(
    {
      id: '/present/audience',
      path: '/present/audience',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRouteImport.update(
    {
      id: '/settings/appearance',
      path: '/settings/appearance',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRouteImport.update(
    {
      id: '/settings/variables',
      path: '/settings/variables',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRouteImport.update(
    {
      id: '/shares/',
      path: '/shares/',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRouteImport.update(
    {
      id: '/shares/new',
      path: '/shares/new',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRouteImport.update(
    {
      id: '/slides/$slideId',
      path: '/slides/$slideId',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRouteImport.update(
    {
      id: '/shares/$shareLinkId/',
      path: '/shares/$shareLinkId/',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )
const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRouteImport.update(
    {
      id: '/shares/$shareLinkId/edit',
      path: '/shares/$shareLinkId/edit',
      getParentRoute: () =>
        ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/early-access': typeof EarlyAccessRoute
  '/features': typeof FeaturesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/manage': typeof ManageRouteWithChildren
  '/mfa-enrollment': typeof MfaEnrollmentRoute
  '/privacy': typeof PrivacyRoute
  '/security': typeof SecurityRoute
  '/templates': typeof TemplatesRoute
  '/terms': typeof TermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/p/$shareId': typeof PShareIdRouteWithChildren
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/visual-qa/render': typeof VisualQaRenderRoute
  '/manage/': typeof ManageIndexRoute
  '/manage/$companySlug/ai-actions': typeof ManageCompanySlugAiActionsRoute
  '/manage/$companySlug/assets': typeof ManageCompanySlugAssetsRoute
  '/manage/$companySlug/dashboard': typeof ManageCompanySlugDashboardRoute
  '/manage/$companySlug/presentations': typeof ManageCompanySlugPresentationsRoute
  '/manage/$companySlug/projects': typeof ManageCompanySlugProjectsRouteWithChildren
  '/manage/$companySlug/settings': typeof ManageCompanySlugSettingsRouteWithChildren
  '/manage/$companySlug/template-categories': typeof ManageCompanySlugTemplateCategoriesRoute
  '/manage/$companySlug/templates': typeof ManageCompanySlugTemplatesRoute
  '/manage/account/security': typeof ManageAccountSecurityRoute
  '/manage/account/sessions': typeof ManageAccountSessionsRoute
  '/p/$shareId/': typeof PShareIdIndexRoute
  '/manage/$companySlug/assets/$assetId': typeof ManageCompanySlugAssetsAssetIdRoute
  '/manage/$companySlug/presentation-copy-proposals/$proposalId': typeof ManageCompanySlugPresentationCopyProposalsProposalIdRoute
  '/manage/$companySlug/projects/$projectId': typeof ManageCompanySlugProjectsProjectIdRouteWithChildren
  '/manage/$companySlug/projects/new': typeof ManageCompanySlugProjectsNewRoute
  '/manage/$companySlug/settings/ai-provider': typeof ManageCompanySlugSettingsAiProviderRoute
  '/manage/$companySlug/settings/audit-log': typeof ManageCompanySlugSettingsAuditLogRoute
  '/manage/$companySlug/settings/company': typeof ManageCompanySlugSettingsCompanyRoute
  '/manage/$companySlug/settings/invitations': typeof ManageCompanySlugSettingsInvitationsRoute
  '/manage/$companySlug/settings/members': typeof ManageCompanySlugSettingsMembersRoute
  '/manage/$companySlug/settings/security': typeof ManageCompanySlugSettingsSecurityRoute
  '/p/$shareId/s/$slidePublicId': typeof PShareIdSSlidePublicIdRoute
  '/manage/$companySlug/projects/': typeof ManageCompanySlugProjectsIndexRoute
  '/manage/$companySlug/settings/': typeof ManageCompanySlugSettingsIndexRoute
  '/manage/$companySlug/projects/$projectId/access': typeof ManageCompanySlugProjectsProjectIdAccessRoute
  '/manage/$companySlug/projects/$projectId/assets': typeof ManageCompanySlugProjectsProjectIdAssetsRoute
  '/manage/$companySlug/projects/$projectId/knowledge': typeof ManageCompanySlugProjectsProjectIdKnowledgeRoute
  '/manage/$companySlug/projects/$projectId/overview': typeof ManageCompanySlugProjectsProjectIdOverviewRoute
  '/manage/$companySlug/projects/$projectId/presentations': typeof ManageCompanySlugProjectsProjectIdPresentationsRouteWithChildren
  '/manage/$companySlug/projects/$projectId/settings': typeof ManageCompanySlugProjectsProjectIdSettingsRoute
  '/manage/$companySlug/projects/$projectId/theme': typeof ManageCompanySlugProjectsProjectIdThemeRoute
  '/manage/$companySlug/settings/invitations/new': typeof ManageCompanySlugSettingsInvitationsNewRoute
  '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId': typeof ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute
  '/manage/$companySlug/templates/new/dynamic-html': typeof ManageCompanySlugTemplatesNewDynamicHtmlRoute
  '/manage/$companySlug/projects/$projectId/': typeof ManageCompanySlugProjectsProjectIdIndexRoute
  '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId': typeof ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteWithChildren
  '/manage/$companySlug/projects/$projectId/presentations/new': typeof ManageCompanySlugProjectsProjectIdPresentationsNewRoute
  '/manage/$companySlug/settings/members/$userId/access': typeof ManageCompanySlugSettingsMembersUserIdAccessRoute
  '/manage/$companySlug/templates/$templateId/drafts/$draftId': typeof ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute
  '/manage/$companySlug/templates/$templateId/versions/$version': typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteWithChildren
  '/manage/$companySlug/projects/$projectId/ai-proposals/': typeof ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/': typeof ManageCompanySlugProjectsProjectIdPresentationsIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute
  '/manage/$companySlug/templates/$templateId/versions/$version/edit': typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/early-access': typeof EarlyAccessRoute
  '/features': typeof FeaturesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/mfa-enrollment': typeof MfaEnrollmentRoute
  '/privacy': typeof PrivacyRoute
  '/security': typeof SecurityRoute
  '/templates': typeof TemplatesRoute
  '/terms': typeof TermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/visual-qa/render': typeof VisualQaRenderRoute
  '/manage': typeof ManageIndexRoute
  '/manage/$companySlug/ai-actions': typeof ManageCompanySlugAiActionsRoute
  '/manage/$companySlug/assets': typeof ManageCompanySlugAssetsRoute
  '/manage/$companySlug/dashboard': typeof ManageCompanySlugDashboardRoute
  '/manage/$companySlug/presentations': typeof ManageCompanySlugPresentationsRoute
  '/manage/$companySlug/template-categories': typeof ManageCompanySlugTemplateCategoriesRoute
  '/manage/$companySlug/templates': typeof ManageCompanySlugTemplatesRoute
  '/manage/account/security': typeof ManageAccountSecurityRoute
  '/manage/account/sessions': typeof ManageAccountSessionsRoute
  '/p/$shareId': typeof PShareIdIndexRoute
  '/manage/$companySlug/assets/$assetId': typeof ManageCompanySlugAssetsAssetIdRoute
  '/manage/$companySlug/presentation-copy-proposals/$proposalId': typeof ManageCompanySlugPresentationCopyProposalsProposalIdRoute
  '/manage/$companySlug/projects/new': typeof ManageCompanySlugProjectsNewRoute
  '/manage/$companySlug/settings/ai-provider': typeof ManageCompanySlugSettingsAiProviderRoute
  '/manage/$companySlug/settings/audit-log': typeof ManageCompanySlugSettingsAuditLogRoute
  '/manage/$companySlug/settings/company': typeof ManageCompanySlugSettingsCompanyRoute
  '/manage/$companySlug/settings/invitations': typeof ManageCompanySlugSettingsInvitationsRoute
  '/manage/$companySlug/settings/members': typeof ManageCompanySlugSettingsMembersRoute
  '/manage/$companySlug/settings/security': typeof ManageCompanySlugSettingsSecurityRoute
  '/p/$shareId/s/$slidePublicId': typeof PShareIdSSlidePublicIdRoute
  '/manage/$companySlug/projects': typeof ManageCompanySlugProjectsIndexRoute
  '/manage/$companySlug/settings': typeof ManageCompanySlugSettingsIndexRoute
  '/manage/$companySlug/projects/$projectId/access': typeof ManageCompanySlugProjectsProjectIdAccessRoute
  '/manage/$companySlug/projects/$projectId/assets': typeof ManageCompanySlugProjectsProjectIdAssetsRoute
  '/manage/$companySlug/projects/$projectId/knowledge': typeof ManageCompanySlugProjectsProjectIdKnowledgeRoute
  '/manage/$companySlug/projects/$projectId/overview': typeof ManageCompanySlugProjectsProjectIdOverviewRoute
  '/manage/$companySlug/projects/$projectId/settings': typeof ManageCompanySlugProjectsProjectIdSettingsRoute
  '/manage/$companySlug/projects/$projectId/theme': typeof ManageCompanySlugProjectsProjectIdThemeRoute
  '/manage/$companySlug/settings/invitations/new': typeof ManageCompanySlugSettingsInvitationsNewRoute
  '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId': typeof ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute
  '/manage/$companySlug/templates/new/dynamic-html': typeof ManageCompanySlugTemplatesNewDynamicHtmlRoute
  '/manage/$companySlug/projects/$projectId': typeof ManageCompanySlugProjectsProjectIdIndexRoute
  '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId': typeof ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/new': typeof ManageCompanySlugProjectsProjectIdPresentationsNewRoute
  '/manage/$companySlug/settings/members/$userId/access': typeof ManageCompanySlugSettingsMembersUserIdAccessRoute
  '/manage/$companySlug/templates/$templateId/drafts/$draftId': typeof ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute
  '/manage/$companySlug/templates/$templateId/versions/$version': typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteWithChildren
  '/manage/$companySlug/projects/$projectId/ai-proposals': typeof ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations': typeof ManageCompanySlugProjectsProjectIdPresentationsIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute
  '/manage/$companySlug/templates/$templateId/versions/$version/edit': typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/early-access': typeof EarlyAccessRoute
  '/features': typeof FeaturesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/manage': typeof ManageRouteWithChildren
  '/mfa-enrollment': typeof MfaEnrollmentRoute
  '/privacy': typeof PrivacyRoute
  '/security': typeof SecurityRoute
  '/templates': typeof TemplatesRoute
  '/terms': typeof TermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/p/$shareId': typeof PShareIdRouteWithChildren
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/visual-qa/render': typeof VisualQaRenderRoute
  '/manage/': typeof ManageIndexRoute
  '/manage/$companySlug/ai-actions': typeof ManageCompanySlugAiActionsRoute
  '/manage/$companySlug/assets': typeof ManageCompanySlugAssetsRoute
  '/manage/$companySlug/dashboard': typeof ManageCompanySlugDashboardRoute
  '/manage/$companySlug/presentations': typeof ManageCompanySlugPresentationsRoute
  '/manage/$companySlug/projects': typeof ManageCompanySlugProjectsRouteWithChildren
  '/manage/$companySlug/settings': typeof ManageCompanySlugSettingsRouteWithChildren
  '/manage/$companySlug/template-categories': typeof ManageCompanySlugTemplateCategoriesRoute
  '/manage/$companySlug/templates': typeof ManageCompanySlugTemplatesRoute
  '/manage/account/security': typeof ManageAccountSecurityRoute
  '/manage/account/sessions': typeof ManageAccountSessionsRoute
  '/p/$shareId/': typeof PShareIdIndexRoute
  '/manage/$companySlug/assets_/$assetId': typeof ManageCompanySlugAssetsAssetIdRoute
  '/manage/$companySlug/presentation-copy-proposals/$proposalId': typeof ManageCompanySlugPresentationCopyProposalsProposalIdRoute
  '/manage/$companySlug/projects/$projectId': typeof ManageCompanySlugProjectsProjectIdRouteWithChildren
  '/manage/$companySlug/projects/new': typeof ManageCompanySlugProjectsNewRoute
  '/manage/$companySlug/settings/ai-provider': typeof ManageCompanySlugSettingsAiProviderRoute
  '/manage/$companySlug/settings/audit-log': typeof ManageCompanySlugSettingsAuditLogRoute
  '/manage/$companySlug/settings/company': typeof ManageCompanySlugSettingsCompanyRoute
  '/manage/$companySlug/settings/invitations': typeof ManageCompanySlugSettingsInvitationsRoute
  '/manage/$companySlug/settings/members': typeof ManageCompanySlugSettingsMembersRoute
  '/manage/$companySlug/settings/security': typeof ManageCompanySlugSettingsSecurityRoute
  '/p/$shareId/s/$slidePublicId': typeof PShareIdSSlidePublicIdRoute
  '/manage/$companySlug/projects/': typeof ManageCompanySlugProjectsIndexRoute
  '/manage/$companySlug/settings/': typeof ManageCompanySlugSettingsIndexRoute
  '/manage/$companySlug/projects/$projectId/access': typeof ManageCompanySlugProjectsProjectIdAccessRoute
  '/manage/$companySlug/projects/$projectId/assets': typeof ManageCompanySlugProjectsProjectIdAssetsRoute
  '/manage/$companySlug/projects/$projectId/knowledge': typeof ManageCompanySlugProjectsProjectIdKnowledgeRoute
  '/manage/$companySlug/projects/$projectId/overview': typeof ManageCompanySlugProjectsProjectIdOverviewRoute
  '/manage/$companySlug/projects/$projectId/presentations': typeof ManageCompanySlugProjectsProjectIdPresentationsRouteWithChildren
  '/manage/$companySlug/projects/$projectId/settings': typeof ManageCompanySlugProjectsProjectIdSettingsRoute
  '/manage/$companySlug/projects/$projectId/theme': typeof ManageCompanySlugProjectsProjectIdThemeRoute
  '/manage/$companySlug/settings/invitations_/new': typeof ManageCompanySlugSettingsInvitationsNewRoute
  '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId': typeof ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute
  '/manage/$companySlug/templates_/new/dynamic-html': typeof ManageCompanySlugTemplatesNewDynamicHtmlRoute
  '/manage/$companySlug/projects/$projectId/': typeof ManageCompanySlugProjectsProjectIdIndexRoute
  '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId': typeof ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteWithChildren
  '/manage/$companySlug/projects/$projectId/presentations/new': typeof ManageCompanySlugProjectsProjectIdPresentationsNewRoute
  '/manage/$companySlug/settings/members_/$userId/access': typeof ManageCompanySlugSettingsMembersUserIdAccessRoute
  '/manage/$companySlug/templates_/$templateId/drafts/$draftId': typeof ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute
  '/manage/$companySlug/templates_/$templateId/versions/$version': typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteWithChildren
  '/manage/$companySlug/projects/$projectId/ai-proposals/': typeof ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/': typeof ManageCompanySlugProjectsProjectIdPresentationsIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute
  '/manage/$companySlug/templates_/$templateId/versions/$version/edit': typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/': typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/early-access'
    | '/features'
    | '/forgot-password'
    | '/login'
    | '/manage'
    | '/mfa-enrollment'
    | '/privacy'
    | '/security'
    | '/templates'
    | '/terms'
    | '/invite/$token'
    | '/p/$shareId'
    | '/reset-password/$token'
    | '/visual-qa/render'
    | '/manage/'
    | '/manage/$companySlug/ai-actions'
    | '/manage/$companySlug/assets'
    | '/manage/$companySlug/dashboard'
    | '/manage/$companySlug/presentations'
    | '/manage/$companySlug/projects'
    | '/manage/$companySlug/settings'
    | '/manage/$companySlug/template-categories'
    | '/manage/$companySlug/templates'
    | '/manage/account/security'
    | '/manage/account/sessions'
    | '/p/$shareId/'
    | '/manage/$companySlug/assets/$assetId'
    | '/manage/$companySlug/presentation-copy-proposals/$proposalId'
    | '/manage/$companySlug/projects/$projectId'
    | '/manage/$companySlug/projects/new'
    | '/manage/$companySlug/settings/ai-provider'
    | '/manage/$companySlug/settings/audit-log'
    | '/manage/$companySlug/settings/company'
    | '/manage/$companySlug/settings/invitations'
    | '/manage/$companySlug/settings/members'
    | '/manage/$companySlug/settings/security'
    | '/p/$shareId/s/$slidePublicId'
    | '/manage/$companySlug/projects/'
    | '/manage/$companySlug/settings/'
    | '/manage/$companySlug/projects/$projectId/access'
    | '/manage/$companySlug/projects/$projectId/assets'
    | '/manage/$companySlug/projects/$projectId/knowledge'
    | '/manage/$companySlug/projects/$projectId/overview'
    | '/manage/$companySlug/projects/$projectId/presentations'
    | '/manage/$companySlug/projects/$projectId/settings'
    | '/manage/$companySlug/projects/$projectId/theme'
    | '/manage/$companySlug/settings/invitations/new'
    | '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId'
    | '/manage/$companySlug/templates/new/dynamic-html'
    | '/manage/$companySlug/projects/$projectId/'
    | '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId'
    | '/manage/$companySlug/projects/$projectId/presentations/new'
    | '/manage/$companySlug/settings/members/$userId/access'
    | '/manage/$companySlug/templates/$templateId/drafts/$draftId'
    | '/manage/$companySlug/templates/$templateId/versions/$version'
    | '/manage/$companySlug/projects/$projectId/ai-proposals/'
    | '/manage/$companySlug/projects/$projectId/presentations/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview'
    | '/manage/$companySlug/templates/$templateId/versions/$version/edit'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/early-access'
    | '/features'
    | '/forgot-password'
    | '/login'
    | '/mfa-enrollment'
    | '/privacy'
    | '/security'
    | '/templates'
    | '/terms'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/visual-qa/render'
    | '/manage'
    | '/manage/$companySlug/ai-actions'
    | '/manage/$companySlug/assets'
    | '/manage/$companySlug/dashboard'
    | '/manage/$companySlug/presentations'
    | '/manage/$companySlug/template-categories'
    | '/manage/$companySlug/templates'
    | '/manage/account/security'
    | '/manage/account/sessions'
    | '/p/$shareId'
    | '/manage/$companySlug/assets/$assetId'
    | '/manage/$companySlug/presentation-copy-proposals/$proposalId'
    | '/manage/$companySlug/projects/new'
    | '/manage/$companySlug/settings/ai-provider'
    | '/manage/$companySlug/settings/audit-log'
    | '/manage/$companySlug/settings/company'
    | '/manage/$companySlug/settings/invitations'
    | '/manage/$companySlug/settings/members'
    | '/manage/$companySlug/settings/security'
    | '/p/$shareId/s/$slidePublicId'
    | '/manage/$companySlug/projects'
    | '/manage/$companySlug/settings'
    | '/manage/$companySlug/projects/$projectId/access'
    | '/manage/$companySlug/projects/$projectId/assets'
    | '/manage/$companySlug/projects/$projectId/knowledge'
    | '/manage/$companySlug/projects/$projectId/overview'
    | '/manage/$companySlug/projects/$projectId/settings'
    | '/manage/$companySlug/projects/$projectId/theme'
    | '/manage/$companySlug/settings/invitations/new'
    | '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId'
    | '/manage/$companySlug/templates/new/dynamic-html'
    | '/manage/$companySlug/projects/$projectId'
    | '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId'
    | '/manage/$companySlug/projects/$projectId/presentations/new'
    | '/manage/$companySlug/settings/members/$userId/access'
    | '/manage/$companySlug/templates/$templateId/drafts/$draftId'
    | '/manage/$companySlug/templates/$templateId/versions/$version'
    | '/manage/$companySlug/projects/$projectId/ai-proposals'
    | '/manage/$companySlug/projects/$projectId/presentations'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview'
    | '/manage/$companySlug/templates/$templateId/versions/$version/edit'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/early-access'
    | '/features'
    | '/forgot-password'
    | '/login'
    | '/manage'
    | '/mfa-enrollment'
    | '/privacy'
    | '/security'
    | '/templates'
    | '/terms'
    | '/invite/$token'
    | '/p/$shareId'
    | '/reset-password/$token'
    | '/visual-qa/render'
    | '/manage/'
    | '/manage/$companySlug/ai-actions'
    | '/manage/$companySlug/assets'
    | '/manage/$companySlug/dashboard'
    | '/manage/$companySlug/presentations'
    | '/manage/$companySlug/projects'
    | '/manage/$companySlug/settings'
    | '/manage/$companySlug/template-categories'
    | '/manage/$companySlug/templates'
    | '/manage/account/security'
    | '/manage/account/sessions'
    | '/p/$shareId/'
    | '/manage/$companySlug/assets_/$assetId'
    | '/manage/$companySlug/presentation-copy-proposals/$proposalId'
    | '/manage/$companySlug/projects/$projectId'
    | '/manage/$companySlug/projects/new'
    | '/manage/$companySlug/settings/ai-provider'
    | '/manage/$companySlug/settings/audit-log'
    | '/manage/$companySlug/settings/company'
    | '/manage/$companySlug/settings/invitations'
    | '/manage/$companySlug/settings/members'
    | '/manage/$companySlug/settings/security'
    | '/p/$shareId/s/$slidePublicId'
    | '/manage/$companySlug/projects/'
    | '/manage/$companySlug/settings/'
    | '/manage/$companySlug/projects/$projectId/access'
    | '/manage/$companySlug/projects/$projectId/assets'
    | '/manage/$companySlug/projects/$projectId/knowledge'
    | '/manage/$companySlug/projects/$projectId/overview'
    | '/manage/$companySlug/projects/$projectId/presentations'
    | '/manage/$companySlug/projects/$projectId/settings'
    | '/manage/$companySlug/projects/$projectId/theme'
    | '/manage/$companySlug/settings/invitations_/new'
    | '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId'
    | '/manage/$companySlug/templates_/new/dynamic-html'
    | '/manage/$companySlug/projects/$projectId/'
    | '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId'
    | '/manage/$companySlug/projects/$projectId/presentations/new'
    | '/manage/$companySlug/settings/members_/$userId/access'
    | '/manage/$companySlug/templates_/$templateId/drafts/$draftId'
    | '/manage/$companySlug/templates_/$templateId/versions/$version'
    | '/manage/$companySlug/projects/$projectId/ai-proposals/'
    | '/manage/$companySlug/projects/$projectId/presentations/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview'
    | '/manage/$companySlug/templates_/$templateId/versions/$version/edit'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit'
    | '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  EarlyAccessRoute: typeof EarlyAccessRoute
  FeaturesRoute: typeof FeaturesRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ManageRoute: typeof ManageRouteWithChildren
  MfaEnrollmentRoute: typeof MfaEnrollmentRoute
  PrivacyRoute: typeof PrivacyRoute
  SecurityRoute: typeof SecurityRoute
  TemplatesRoute: typeof TemplatesRoute
  TermsRoute: typeof TermsRoute
  InviteTokenRoute: typeof InviteTokenRoute
  PShareIdRoute: typeof PShareIdRouteWithChildren
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  VisualQaRenderRoute: typeof VisualQaRenderRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early-access': {
      id: '/early-access'
      path: '/early-access'
      fullPath: '/early-access'
      preLoaderRoute: typeof EarlyAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-enrollment': {
      id: '/mfa-enrollment'
      path: '/mfa-enrollment'
      fullPath: '/mfa-enrollment'
      preLoaderRoute: typeof MfaEnrollmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage/': {
      id: '/manage/'
      path: '/'
      fullPath: '/manage/'
      preLoaderRoute: typeof ManageIndexRouteImport
      parentRoute: typeof ManageRoute
    }
    '/p/$shareId': {
      id: '/p/$shareId'
      path: '/p/$shareId'
      fullPath: '/p/$shareId'
      preLoaderRoute: typeof PShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/visual-qa/render': {
      id: '/visual-qa/render'
      path: '/visual-qa/render'
      fullPath: '/visual-qa/render'
      preLoaderRoute: typeof VisualQaRenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage/$companySlug/ai-actions': {
      id: '/manage/$companySlug/ai-actions'
      path: '/$companySlug/ai-actions'
      fullPath: '/manage/$companySlug/ai-actions'
      preLoaderRoute: typeof ManageCompanySlugAiActionsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/assets': {
      id: '/manage/$companySlug/assets'
      path: '/$companySlug/assets'
      fullPath: '/manage/$companySlug/assets'
      preLoaderRoute: typeof ManageCompanySlugAssetsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/dashboard': {
      id: '/manage/$companySlug/dashboard'
      path: '/$companySlug/dashboard'
      fullPath: '/manage/$companySlug/dashboard'
      preLoaderRoute: typeof ManageCompanySlugDashboardRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/presentations': {
      id: '/manage/$companySlug/presentations'
      path: '/$companySlug/presentations'
      fullPath: '/manage/$companySlug/presentations'
      preLoaderRoute: typeof ManageCompanySlugPresentationsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/projects': {
      id: '/manage/$companySlug/projects'
      path: '/$companySlug/projects'
      fullPath: '/manage/$companySlug/projects'
      preLoaderRoute: typeof ManageCompanySlugProjectsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/settings': {
      id: '/manage/$companySlug/settings'
      path: '/$companySlug/settings'
      fullPath: '/manage/$companySlug/settings'
      preLoaderRoute: typeof ManageCompanySlugSettingsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/template-categories': {
      id: '/manage/$companySlug/template-categories'
      path: '/$companySlug/template-categories'
      fullPath: '/manage/$companySlug/template-categories'
      preLoaderRoute: typeof ManageCompanySlugTemplateCategoriesRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/templates': {
      id: '/manage/$companySlug/templates'
      path: '/$companySlug/templates'
      fullPath: '/manage/$companySlug/templates'
      preLoaderRoute: typeof ManageCompanySlugTemplatesRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/account/security': {
      id: '/manage/account/security'
      path: '/account/security'
      fullPath: '/manage/account/security'
      preLoaderRoute: typeof ManageAccountSecurityRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/account/sessions': {
      id: '/manage/account/sessions'
      path: '/account/sessions'
      fullPath: '/manage/account/sessions'
      preLoaderRoute: typeof ManageAccountSessionsRouteImport
      parentRoute: typeof ManageRoute
    }
    '/p/$shareId/': {
      id: '/p/$shareId/'
      path: '/'
      fullPath: '/p/$shareId/'
      preLoaderRoute: typeof PShareIdIndexRouteImport
      parentRoute: typeof PShareIdRoute
    }
    '/manage/$companySlug/assets_/$assetId': {
      id: '/manage/$companySlug/assets_/$assetId'
      path: '/$companySlug/assets/$assetId'
      fullPath: '/manage/$companySlug/assets/$assetId'
      preLoaderRoute: typeof ManageCompanySlugAssetsAssetIdRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/presentation-copy-proposals/$proposalId': {
      id: '/manage/$companySlug/presentation-copy-proposals/$proposalId'
      path: '/$companySlug/presentation-copy-proposals/$proposalId'
      fullPath: '/manage/$companySlug/presentation-copy-proposals/$proposalId'
      preLoaderRoute: typeof ManageCompanySlugPresentationCopyProposalsProposalIdRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/projects/': {
      id: '/manage/$companySlug/projects/'
      path: '/'
      fullPath: '/manage/$companySlug/projects/'
      preLoaderRoute: typeof ManageCompanySlugProjectsIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsRoute
    }
    '/manage/$companySlug/projects/$projectId': {
      id: '/manage/$companySlug/projects/$projectId'
      path: '/$projectId'
      fullPath: '/manage/$companySlug/projects/$projectId'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdRouteImport
      parentRoute: typeof ManageCompanySlugProjectsRoute
    }
    '/manage/$companySlug/projects/new': {
      id: '/manage/$companySlug/projects/new'
      path: '/new'
      fullPath: '/manage/$companySlug/projects/new'
      preLoaderRoute: typeof ManageCompanySlugProjectsNewRouteImport
      parentRoute: typeof ManageCompanySlugProjectsRoute
    }
    '/manage/$companySlug/settings/': {
      id: '/manage/$companySlug/settings/'
      path: '/'
      fullPath: '/manage/$companySlug/settings/'
      preLoaderRoute: typeof ManageCompanySlugSettingsIndexRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/settings/ai-provider': {
      id: '/manage/$companySlug/settings/ai-provider'
      path: '/ai-provider'
      fullPath: '/manage/$companySlug/settings/ai-provider'
      preLoaderRoute: typeof ManageCompanySlugSettingsAiProviderRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/settings/audit-log': {
      id: '/manage/$companySlug/settings/audit-log'
      path: '/audit-log'
      fullPath: '/manage/$companySlug/settings/audit-log'
      preLoaderRoute: typeof ManageCompanySlugSettingsAuditLogRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/settings/company': {
      id: '/manage/$companySlug/settings/company'
      path: '/company'
      fullPath: '/manage/$companySlug/settings/company'
      preLoaderRoute: typeof ManageCompanySlugSettingsCompanyRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/settings/invitations': {
      id: '/manage/$companySlug/settings/invitations'
      path: '/invitations'
      fullPath: '/manage/$companySlug/settings/invitations'
      preLoaderRoute: typeof ManageCompanySlugSettingsInvitationsRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/settings/members': {
      id: '/manage/$companySlug/settings/members'
      path: '/members'
      fullPath: '/manage/$companySlug/settings/members'
      preLoaderRoute: typeof ManageCompanySlugSettingsMembersRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/settings/security': {
      id: '/manage/$companySlug/settings/security'
      path: '/security'
      fullPath: '/manage/$companySlug/settings/security'
      preLoaderRoute: typeof ManageCompanySlugSettingsSecurityRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/p/$shareId/s/$slidePublicId': {
      id: '/p/$shareId/s/$slidePublicId'
      path: '/s/$slidePublicId'
      fullPath: '/p/$shareId/s/$slidePublicId'
      preLoaderRoute: typeof PShareIdSSlidePublicIdRouteImport
      parentRoute: typeof PShareIdRoute
    }
    '/manage/$companySlug/projects/$projectId/': {
      id: '/manage/$companySlug/projects/$projectId/'
      path: '/'
      fullPath: '/manage/$companySlug/projects/$projectId/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/access': {
      id: '/manage/$companySlug/projects/$projectId/access'
      path: '/access'
      fullPath: '/manage/$companySlug/projects/$projectId/access'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdAccessRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/assets': {
      id: '/manage/$companySlug/projects/$projectId/assets'
      path: '/assets'
      fullPath: '/manage/$companySlug/projects/$projectId/assets'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdAssetsRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/knowledge': {
      id: '/manage/$companySlug/projects/$projectId/knowledge'
      path: '/knowledge'
      fullPath: '/manage/$companySlug/projects/$projectId/knowledge'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdKnowledgeRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/overview': {
      id: '/manage/$companySlug/projects/$projectId/overview'
      path: '/overview'
      fullPath: '/manage/$companySlug/projects/$projectId/overview'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdOverviewRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations': {
      id: '/manage/$companySlug/projects/$projectId/presentations'
      path: '/presentations'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/settings': {
      id: '/manage/$companySlug/projects/$projectId/settings'
      path: '/settings'
      fullPath: '/manage/$companySlug/projects/$projectId/settings'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdSettingsRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/theme': {
      id: '/manage/$companySlug/projects/$projectId/theme'
      path: '/theme'
      fullPath: '/manage/$companySlug/projects/$projectId/theme'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdThemeRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/settings/invitations_/new': {
      id: '/manage/$companySlug/settings/invitations_/new'
      path: '/invitations/new'
      fullPath: '/manage/$companySlug/settings/invitations/new'
      preLoaderRoute: typeof ManageCompanySlugSettingsInvitationsNewRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId': {
      id: '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId'
      path: '/$companySlug/share-link-change-proposals/$presentationId/$proposalId'
      fullPath: '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId'
      preLoaderRoute: typeof ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/templates_/new/dynamic-html': {
      id: '/manage/$companySlug/templates_/new/dynamic-html'
      path: '/$companySlug/templates/new/dynamic-html'
      fullPath: '/manage/$companySlug/templates/new/dynamic-html'
      preLoaderRoute: typeof ManageCompanySlugTemplatesNewDynamicHtmlRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/projects/$projectId/ai-proposals/': {
      id: '/manage/$companySlug/projects/$projectId/ai-proposals/'
      path: '/ai-proposals'
      fullPath: '/manage/$companySlug/projects/$projectId/ai-proposals/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdAiProposalsIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId': {
      id: '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId'
      path: '/ai-proposals/$proposalId'
      fullPath: '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/': {
      id: '/manage/$companySlug/projects/$projectId/presentations/'
      path: '/'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId'
      path: '/$presentationId'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/new': {
      id: '/manage/$companySlug/projects/$projectId/presentations/new'
      path: '/new'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/new'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsNewRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsRoute
    }
    '/manage/$companySlug/settings/members_/$userId/access': {
      id: '/manage/$companySlug/settings/members_/$userId/access'
      path: '/members/$userId/access'
      fullPath: '/manage/$companySlug/settings/members/$userId/access'
      preLoaderRoute: typeof ManageCompanySlugSettingsMembersUserIdAccessRouteImport
      parentRoute: typeof ManageCompanySlugSettingsRoute
    }
    '/manage/$companySlug/templates_/$templateId/drafts/$draftId': {
      id: '/manage/$companySlug/templates_/$templateId/drafts/$draftId'
      path: '/$companySlug/templates/$templateId/drafts/$draftId'
      fullPath: '/manage/$companySlug/templates/$templateId/drafts/$draftId'
      preLoaderRoute: typeof ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/templates_/$templateId/versions/$version': {
      id: '/manage/$companySlug/templates_/$templateId/versions/$version'
      path: '/$companySlug/templates/$templateId/versions/$version'
      fullPath: '/manage/$companySlug/templates/$templateId/versions/$version'
      preLoaderRoute: typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteImport
      parentRoute: typeof ManageRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/'
      path: '/'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access'
      path: '/access'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics'
      path: '/analytics'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview'
      path: '/overview'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview'
      path: '/preview'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/preview'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/templates_/$templateId/versions/$version/edit': {
      id: '/manage/$companySlug/templates_/$templateId/versions/$version/edit'
      path: '/edit'
      fullPath: '/manage/$companySlug/templates/$templateId/versions/$version/edit'
      preLoaderRoute: typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRouteImport
      parentRoute: typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/'
      path: '/present'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId'
      path: '/present/$slideId'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/$slideId'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience'
      path: '/present/audience'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/present/audience'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/appearance'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables'
      path: '/settings/variables'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/settings/variables'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/'
      path: '/shares'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new'
      path: '/shares/new'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId'
      path: '/slides/$slideId'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/'
      path: '/shares/$shareLinkId'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
    '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit': {
      id: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit'
      path: '/shares/$shareLinkId/edit'
      fullPath: '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit'
      preLoaderRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRouteImport
      parentRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute
    }
  }
}

interface ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteChildren {
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute
}

const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteChildren: ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteChildren =
  {
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAccessRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdAnalyticsRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdOverviewRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPreviewRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdIndexRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentSlideIdRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentAudienceRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsAppearanceRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSettingsVariablesRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesNewRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSlidesSlideIdRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdPresentIndexRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesIndexRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdEditRoute,
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdSharesShareLinkIdIndexRoute,
  }

const ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteWithChildren =
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute._addFileChildren(
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteChildren,
  )

interface ManageCompanySlugProjectsProjectIdPresentationsRouteChildren {
  ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteWithChildren
  ManageCompanySlugProjectsProjectIdPresentationsNewRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsNewRoute
  ManageCompanySlugProjectsProjectIdPresentationsIndexRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsIndexRoute
}

const ManageCompanySlugProjectsProjectIdPresentationsRouteChildren: ManageCompanySlugProjectsProjectIdPresentationsRouteChildren =
  {
    ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRoute:
      ManageCompanySlugProjectsProjectIdPresentationsPresentationIdRouteWithChildren,
    ManageCompanySlugProjectsProjectIdPresentationsNewRoute:
      ManageCompanySlugProjectsProjectIdPresentationsNewRoute,
    ManageCompanySlugProjectsProjectIdPresentationsIndexRoute:
      ManageCompanySlugProjectsProjectIdPresentationsIndexRoute,
  }

const ManageCompanySlugProjectsProjectIdPresentationsRouteWithChildren =
  ManageCompanySlugProjectsProjectIdPresentationsRoute._addFileChildren(
    ManageCompanySlugProjectsProjectIdPresentationsRouteChildren,
  )

interface ManageCompanySlugProjectsProjectIdRouteChildren {
  ManageCompanySlugProjectsProjectIdAccessRoute: typeof ManageCompanySlugProjectsProjectIdAccessRoute
  ManageCompanySlugProjectsProjectIdAssetsRoute: typeof ManageCompanySlugProjectsProjectIdAssetsRoute
  ManageCompanySlugProjectsProjectIdKnowledgeRoute: typeof ManageCompanySlugProjectsProjectIdKnowledgeRoute
  ManageCompanySlugProjectsProjectIdOverviewRoute: typeof ManageCompanySlugProjectsProjectIdOverviewRoute
  ManageCompanySlugProjectsProjectIdPresentationsRoute: typeof ManageCompanySlugProjectsProjectIdPresentationsRouteWithChildren
  ManageCompanySlugProjectsProjectIdSettingsRoute: typeof ManageCompanySlugProjectsProjectIdSettingsRoute
  ManageCompanySlugProjectsProjectIdThemeRoute: typeof ManageCompanySlugProjectsProjectIdThemeRoute
  ManageCompanySlugProjectsProjectIdIndexRoute: typeof ManageCompanySlugProjectsProjectIdIndexRoute
  ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute: typeof ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute
  ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute: typeof ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute
}

const ManageCompanySlugProjectsProjectIdRouteChildren: ManageCompanySlugProjectsProjectIdRouteChildren =
  {
    ManageCompanySlugProjectsProjectIdAccessRoute:
      ManageCompanySlugProjectsProjectIdAccessRoute,
    ManageCompanySlugProjectsProjectIdAssetsRoute:
      ManageCompanySlugProjectsProjectIdAssetsRoute,
    ManageCompanySlugProjectsProjectIdKnowledgeRoute:
      ManageCompanySlugProjectsProjectIdKnowledgeRoute,
    ManageCompanySlugProjectsProjectIdOverviewRoute:
      ManageCompanySlugProjectsProjectIdOverviewRoute,
    ManageCompanySlugProjectsProjectIdPresentationsRoute:
      ManageCompanySlugProjectsProjectIdPresentationsRouteWithChildren,
    ManageCompanySlugProjectsProjectIdSettingsRoute:
      ManageCompanySlugProjectsProjectIdSettingsRoute,
    ManageCompanySlugProjectsProjectIdThemeRoute:
      ManageCompanySlugProjectsProjectIdThemeRoute,
    ManageCompanySlugProjectsProjectIdIndexRoute:
      ManageCompanySlugProjectsProjectIdIndexRoute,
    ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute:
      ManageCompanySlugProjectsProjectIdAiProposalsProposalIdRoute,
    ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute:
      ManageCompanySlugProjectsProjectIdAiProposalsIndexRoute,
  }

const ManageCompanySlugProjectsProjectIdRouteWithChildren =
  ManageCompanySlugProjectsProjectIdRoute._addFileChildren(
    ManageCompanySlugProjectsProjectIdRouteChildren,
  )

interface ManageCompanySlugProjectsRouteChildren {
  ManageCompanySlugProjectsProjectIdRoute: typeof ManageCompanySlugProjectsProjectIdRouteWithChildren
  ManageCompanySlugProjectsNewRoute: typeof ManageCompanySlugProjectsNewRoute
  ManageCompanySlugProjectsIndexRoute: typeof ManageCompanySlugProjectsIndexRoute
}

const ManageCompanySlugProjectsRouteChildren: ManageCompanySlugProjectsRouteChildren =
  {
    ManageCompanySlugProjectsProjectIdRoute:
      ManageCompanySlugProjectsProjectIdRouteWithChildren,
    ManageCompanySlugProjectsNewRoute: ManageCompanySlugProjectsNewRoute,
    ManageCompanySlugProjectsIndexRoute: ManageCompanySlugProjectsIndexRoute,
  }

const ManageCompanySlugProjectsRouteWithChildren =
  ManageCompanySlugProjectsRoute._addFileChildren(
    ManageCompanySlugProjectsRouteChildren,
  )

interface ManageCompanySlugSettingsRouteChildren {
  ManageCompanySlugSettingsAiProviderRoute: typeof ManageCompanySlugSettingsAiProviderRoute
  ManageCompanySlugSettingsAuditLogRoute: typeof ManageCompanySlugSettingsAuditLogRoute
  ManageCompanySlugSettingsCompanyRoute: typeof ManageCompanySlugSettingsCompanyRoute
  ManageCompanySlugSettingsInvitationsRoute: typeof ManageCompanySlugSettingsInvitationsRoute
  ManageCompanySlugSettingsMembersRoute: typeof ManageCompanySlugSettingsMembersRoute
  ManageCompanySlugSettingsSecurityRoute: typeof ManageCompanySlugSettingsSecurityRoute
  ManageCompanySlugSettingsIndexRoute: typeof ManageCompanySlugSettingsIndexRoute
  ManageCompanySlugSettingsInvitationsNewRoute: typeof ManageCompanySlugSettingsInvitationsNewRoute
  ManageCompanySlugSettingsMembersUserIdAccessRoute: typeof ManageCompanySlugSettingsMembersUserIdAccessRoute
}

const ManageCompanySlugSettingsRouteChildren: ManageCompanySlugSettingsRouteChildren =
  {
    ManageCompanySlugSettingsAiProviderRoute:
      ManageCompanySlugSettingsAiProviderRoute,
    ManageCompanySlugSettingsAuditLogRoute:
      ManageCompanySlugSettingsAuditLogRoute,
    ManageCompanySlugSettingsCompanyRoute:
      ManageCompanySlugSettingsCompanyRoute,
    ManageCompanySlugSettingsInvitationsRoute:
      ManageCompanySlugSettingsInvitationsRoute,
    ManageCompanySlugSettingsMembersRoute:
      ManageCompanySlugSettingsMembersRoute,
    ManageCompanySlugSettingsSecurityRoute:
      ManageCompanySlugSettingsSecurityRoute,
    ManageCompanySlugSettingsIndexRoute: ManageCompanySlugSettingsIndexRoute,
    ManageCompanySlugSettingsInvitationsNewRoute:
      ManageCompanySlugSettingsInvitationsNewRoute,
    ManageCompanySlugSettingsMembersUserIdAccessRoute:
      ManageCompanySlugSettingsMembersUserIdAccessRoute,
  }

const ManageCompanySlugSettingsRouteWithChildren =
  ManageCompanySlugSettingsRoute._addFileChildren(
    ManageCompanySlugSettingsRouteChildren,
  )

interface ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteChildren {
  ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute: typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute
}

const ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteChildren: ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteChildren =
  {
    ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute:
      ManageCompanySlugTemplatesTemplateIdVersionsVersionEditRoute,
  }

const ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteWithChildren =
  ManageCompanySlugTemplatesTemplateIdVersionsVersionRoute._addFileChildren(
    ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteChildren,
  )

interface ManageRouteChildren {
  ManageIndexRoute: typeof ManageIndexRoute
  ManageCompanySlugAiActionsRoute: typeof ManageCompanySlugAiActionsRoute
  ManageCompanySlugAssetsRoute: typeof ManageCompanySlugAssetsRoute
  ManageCompanySlugDashboardRoute: typeof ManageCompanySlugDashboardRoute
  ManageCompanySlugPresentationsRoute: typeof ManageCompanySlugPresentationsRoute
  ManageCompanySlugProjectsRoute: typeof ManageCompanySlugProjectsRouteWithChildren
  ManageCompanySlugSettingsRoute: typeof ManageCompanySlugSettingsRouteWithChildren
  ManageCompanySlugTemplateCategoriesRoute: typeof ManageCompanySlugTemplateCategoriesRoute
  ManageCompanySlugTemplatesRoute: typeof ManageCompanySlugTemplatesRoute
  ManageAccountSecurityRoute: typeof ManageAccountSecurityRoute
  ManageAccountSessionsRoute: typeof ManageAccountSessionsRoute
  ManageCompanySlugAssetsAssetIdRoute: typeof ManageCompanySlugAssetsAssetIdRoute
  ManageCompanySlugPresentationCopyProposalsProposalIdRoute: typeof ManageCompanySlugPresentationCopyProposalsProposalIdRoute
  ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute: typeof ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute
  ManageCompanySlugTemplatesNewDynamicHtmlRoute: typeof ManageCompanySlugTemplatesNewDynamicHtmlRoute
  ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute: typeof ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute
  ManageCompanySlugTemplatesTemplateIdVersionsVersionRoute: typeof ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteWithChildren
}

const ManageRouteChildren: ManageRouteChildren = {
  ManageIndexRoute: ManageIndexRoute,
  ManageCompanySlugAiActionsRoute: ManageCompanySlugAiActionsRoute,
  ManageCompanySlugAssetsRoute: ManageCompanySlugAssetsRoute,
  ManageCompanySlugDashboardRoute: ManageCompanySlugDashboardRoute,
  ManageCompanySlugPresentationsRoute: ManageCompanySlugPresentationsRoute,
  ManageCompanySlugProjectsRoute: ManageCompanySlugProjectsRouteWithChildren,
  ManageCompanySlugSettingsRoute: ManageCompanySlugSettingsRouteWithChildren,
  ManageCompanySlugTemplateCategoriesRoute:
    ManageCompanySlugTemplateCategoriesRoute,
  ManageCompanySlugTemplatesRoute: ManageCompanySlugTemplatesRoute,
  ManageAccountSecurityRoute: ManageAccountSecurityRoute,
  ManageAccountSessionsRoute: ManageAccountSessionsRoute,
  ManageCompanySlugAssetsAssetIdRoute: ManageCompanySlugAssetsAssetIdRoute,
  ManageCompanySlugPresentationCopyProposalsProposalIdRoute:
    ManageCompanySlugPresentationCopyProposalsProposalIdRoute,
  ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute:
    ManageCompanySlugShareLinkChangeProposalsPresentationIdProposalIdRoute,
  ManageCompanySlugTemplatesNewDynamicHtmlRoute:
    ManageCompanySlugTemplatesNewDynamicHtmlRoute,
  ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute:
    ManageCompanySlugTemplatesTemplateIdDraftsDraftIdRoute,
  ManageCompanySlugTemplatesTemplateIdVersionsVersionRoute:
    ManageCompanySlugTemplatesTemplateIdVersionsVersionRouteWithChildren,
}

const ManageRouteWithChildren =
  ManageRoute._addFileChildren(ManageRouteChildren)

interface PShareIdRouteChildren {
  PShareIdIndexRoute: typeof PShareIdIndexRoute
  PShareIdSSlidePublicIdRoute: typeof PShareIdSSlidePublicIdRoute
}

const PShareIdRouteChildren: PShareIdRouteChildren = {
  PShareIdIndexRoute: PShareIdIndexRoute,
  PShareIdSSlidePublicIdRoute: PShareIdSSlidePublicIdRoute,
}

const PShareIdRouteWithChildren = PShareIdRoute._addFileChildren(
  PShareIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  EarlyAccessRoute: EarlyAccessRoute,
  FeaturesRoute: FeaturesRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ManageRoute: ManageRouteWithChildren,
  MfaEnrollmentRoute: MfaEnrollmentRoute,
  PrivacyRoute: PrivacyRoute,
  SecurityRoute: SecurityRoute,
  TemplatesRoute: TemplatesRoute,
  TermsRoute: TermsRoute,
  InviteTokenRoute: InviteTokenRoute,
  PShareIdRoute: PShareIdRouteWithChildren,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  VisualQaRenderRoute: VisualQaRenderRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
